import generalRu from '../locales/ru.json';

export const resourcesRU = {
  general: generalRu,
};
